import React from 'react';
import ReactDOM from 'react-dom';
import { Button } from '../Button';

interface ConfirmModalProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    title?: string;
    message: string;
    body?: React.ReactNode;
    confirmLabel?: string;
    confirmVariant?: 'primary' | 'secondary';
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
    open,
    onClose,
    onConfirm,
    title = 'Confirm Action',
    message,
    body,
    confirmLabel = 'Delete',
    confirmVariant = 'secondary',
}) => {
    if (!open) return null;

    return ReactDOM.createPortal(
        <div
            className="fixed inset-0 z-[9999] flex items-center justify-center bg-slate-900/50 backdrop-blur-[1px]"
            onClick={onClose}
            role="presentation"
        >
            <div
                className="bg-white dark:bg-slate-800 rounded-2xl shadow-2xl p-6 w-full max-w-md mx-4 border border-slate-200 dark:border-slate-700"
                onClick={(e) => e.stopPropagation()}
                role="dialog"
                aria-modal="true"
                aria-labelledby="confirm-modal-title"
            >
                <h3 id="confirm-modal-title" className="text-xl font-semibold text-slate-900 dark:text-gray-100 mb-3">
                    {title}
                </h3>
                <p className="text-slate-600 dark:text-gray-300 mb-6 leading-6">
                    {message}
                </p>
                {body && <div className="mb-6">{body}</div>}
                <div className="flex justify-end gap-3">
                    <Button variant="secondary" size="md" onClick={onClose}>
                        Cancel
                    </Button>
                    <Button variant={confirmVariant} size="md" onClick={onConfirm}>
                        {confirmLabel}
                    </Button>
                </div>
            </div>
        </div>,
        document.body,
    );
};

export default ConfirmModal;
